import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AdminLeftMenu from "./AdminLeftMenu";
import { useTranslation } from "react-i18next";
import AdminCheck from "./AdminCheck";

import ReactQuill from "react-quill";
import Editor_Modify from "./Editor_Modify";
import "react-quill/dist/quill.snow.css";
import "./MessageBoard.css";

const Board = () => {
  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%", pb: 10 }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px" }}>한국 쇼핑몰 공지사항</Box>
              </Box>

              <Grid container spacing={2}>
                <Grid item md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      backgroundColor: "white",
                      minHeight: "500px",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "15px",
                      }}
                    >
                      <Box>공지사항을 적어주세요</Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        px: 4,
                        py: 3,
                        pt: 2,
                      }}
                    >
                      <Editor_Modify />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Board;
// users
